export const environment = {
    baseUrl: 'https://staging-api.socialtravels.it',
    mediaUrl: 'https://storage-dev.zetra.it/media/st-dev',
};
